import { render, staticRenderFns } from "./NsPopup.vue?vue&type=template&id=15528344&scoped=true&"
import script from "./NsPopup.vue?vue&type=script&lang=js&"
export * from "./NsPopup.vue?vue&type=script&lang=js&"
import style0 from "./NsPopup.vue?vue&type=style&index=0&id=15528344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15528344",
  null
  
)

export default component.exports